const colors = {
  textColor: "#517F2C",
  activeTextColor: "#fff",
  borderColor: "#fff",
  activeZoneColor: "#517F2C",
  defaultZoneColor: "#89BE38",
};

const districtsMap = document.querySelector("#district-map");
const descriptionBlock = document.querySelector("#district-map-description");

if (districtsMap) {
  const nameField = descriptionBlock.querySelector(".district-name");
  const machineField = descriptionBlock.querySelector(".machine-field");
  const heField = descriptionBlock.querySelector(".he-field");
  const zones = districtsMap.querySelectorAll(".map-zone");
  setDefaultZone();
  zones.forEach(function (zone) {
    const zoneData = getZoneData(zone);
    const isActiveZone = !!zoneData;
    if (isActiveZone) {
      zone.style.fill = colors.defaultZoneColor;
    }
    const textNodes = isActiveZone
      ? document.querySelectorAll(
          ".map-text[data-district='" + zoneData?.district + "']"
        )
      : null;
    zone.addEventListener("mouseover", function () {
      if (!isActiveZone) return;
      setActivePathStyles(zone, textNodes, isActiveZone);
      setZoneData(zoneData);
    });
    zone.addEventListener("mouseout", function () {
      removeActivePathStyles(zone, textNodes, isActiveZone);
      setDefaultZone();
    });
  });

  function setActivePathStyles(node, textNodes, isActiveZone) {
    node.style.stroke = "white";
    node.style.strokeWidth = "2";
    if (isActiveZone) {
      node.style.fill = colors.activeZoneColor;
    }
    if (textNodes) {
      textNodes.forEach((element) => {
        element.style.fill = colors.activeTextColor;
      });
    }
  }

  function removeActivePathStyles(node, textNodes, isActiveZone) {
    node.style.stroke = "white";
    node.style.strokeWidth = "0";
    if (isActiveZone) {
      node.style.fill = colors.defaultZoneColor;
    }
    if (textNodes) {
      textNodes.forEach((element) => {
        element.style.fill = colors.textColor;
      });
    }
  }

  function getZoneData(node) {
    const district = node.getAttribute("data-district");
    if (
      !district ||
      !window.dataProjectsMap ||
      !window.dataProjectsMap[district] ||
      !Object.keys(window.dataProjectsMap[district]).length
    )
      return null;
    return {
      data: window.dataProjectsMap[district],
      district: district,
    };
  }

  function setZoneData(districtData) {
    if (!districtData) return;
    const data = districtData.data;
    nameField.innerHTML = data.name;
    machineField.innerHTML = data.machines;
    heField.innerHTML = data.he;
    descriptionBlock.style.visibility = "visible";
  }

  function setDefaultZone() {
    const district = 'ukraine';
    if (
      !district ||
      !window.dataProjectsMap ||
      !window.dataProjectsMap[district] ||
      !Object.keys(window.dataProjectsMap[district]).length
    ) {
      descriptionBlock.style.visibility = "hidden";
    } else {
      setZoneData({
        data: window.dataProjectsMap[district],
        district: district,
      });
    }
  }
}
